import { render } from "./BlogPost.vue?vue&type=template&id=03e3a224"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"
script.render = render

export default script